export default "__VITE_ASSET__tFz1GPzX__"